import { DataTable } from "@/components/data-table";
import { Form, useForm } from "@/components/form";
import { useGetAllProveedoresQuery } from "@/features/auxiliar/proveedores/api/get-all-proveedores";
import { formatString } from "@/shared/formats";
import { Proveedor } from "@/shared/types/proveedor";
import { IconButton, Stack, StackProps } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useFilters } from "@/components/filters";

interface ProveedorSearchProps extends StackProps {
    onProveedorSelect?: (proveedor: Proveedor) => void
}

export default function CompraProveedorManualSearch({
    onProveedorSelect,
    ...props
}: ProveedorSearchProps) {
    const filterData = useFilters({
        useURL: false,
        filters: [
            { type: "string", label: "Nombre", name: "nombre" },
            { type: "string", label: "N° Documento", name: "numDocumento" },
            { type: "string", label: "Teléfono", name: "telefono" },
            { type: "string", label: "Email", name: "email" },
            { type: "pagination" }
        ]
    })

    const queryResult = useGetAllProveedoresQuery(filterData.filterData);

    const filterForm = useForm({
        defaultValues: filterData.filterData,
        onSubmit: ({ value }) => filterData.setFilterData(value),
        closeModalOnSubmit: false,
        submitOnce: false,
    })

    return <Stack minHeight={"70vh"} gap={3} {...props}>
        <Form form={filterForm} direction={"row"} flexWrap={"wrap"} gap={2}>
            <Form.TextField name="nombre" label="Nombre" size="small" />
            <Form.TextField name="numDocumento" label="N° Documento" size="small" />
            <Form.TextField name="telefono" label="Teléfono" size="small" />
            <Form.TextField name="email" label="Email" size="small" />
            <Form.SubmitButton>Filtrar</Form.SubmitButton>
        </Form>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={queryResult.data?.result}
                loading={queryResult.isFetching}
                columns={[
                    { key: "nombre", header: "Nombre", render: row => formatString(row.nombre) },
                    { key: "numDocumento", header: "N° Documento", render: row => formatString(row.numDocumento) },
                    { key: "telefono", header: "Teléfono", render: row => formatString(row.telefono) },
                    { key: "email", header: "Email", render: row => formatString(row.email) },
                    {
                        header: "", align: "center", width: "auto",
                        render: a => <IconButton onClick={() => onProveedorSelect && onProveedorSelect(a)}>
                            <AddIcon />
                        </IconButton>
                    }
                ]}
            />
            <DataTable.Pagination queryResult={queryResult} filterData={filterData} />
        </DataTable>
    </Stack>
}